"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Clock, User } from "lucide-react";
function TechPerspectivesConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4 rounded-xl border border-border bg-card p-4">
            <div className="h-56 w-full animate-pulse rounded-[10px] bg-muted/20" />
            <div className="h-6 w-24 animate-pulse rounded bg-muted/20" />
            <div className="h-8 w-3/4 animate-pulse rounded bg-muted/20" />
            <div className="mt-auto flex items-center gap-2">
              <div className="size-8 animate-pulse rounded-full bg-muted/20" />
              <div className="h-4 w-24 animate-pulse rounded bg-muted/20" />
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex min-h-[300px] flex-col items-center justify-center text-center">
        <p className="mb-4 text-muted-foreground">
          Unable to load insights at this time.
        </p>
        <Button onClick={refetch} variant="outline">
          Try Again
        </Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="flex min-h-[200px] items-center justify-center text-muted-foreground">
        No perspectives found.
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => {
      const category = post.categories?.[0]?.name || "Technology";
      const authorName = post.author?.name || "Inara Team";
      const imageUrl = post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558991/img/generic_tech_abstract.png";
      return <Link key={post.id} to={post.link || "#"} className="group block h-full" data-index={i}>
            <Card className="h-full border-border bg-card/50 transition-colors hover:border-primary/50 hover:bg-card">
              <CardContent className="flex h-full flex-col p-5">
                {}
                <div className="mb-6 overflow-hidden rounded-[10px]">
                  <img src={imageUrl} alt={post.title} className="aspect-video w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>

                {}
                <div className="mb-3">
                  <Badge variant="outline" className="border-chart-2/20 bg-chart-2/10 text-chart-2 hover:bg-chart-2/20 hover:text-chart-2">
                    {category}
                  </Badge>
                </div>

                {}
                <h3 className="mb-3 font-sans text-xl font-bold leading-tight text-foreground group-hover:text-primary">
                  {post.title}
                </h3>

                {}
                <div className="mt-auto flex items-center justify-between border-t border-border/50 pt-4 text-sm text-muted-foreground">
                  <div className="flex items-center gap-2">
                    <User className="size-4 text-primary" />
                    <span className="font-medium text-foreground">{authorName}</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <Clock className="size-3.5" />
                    <span>5 min read</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </Link>;
    })}
    </div>;
}
export default function TechPerspectives() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="tech-perspectives" className="dark bg-background py-20 text-foreground">
      <div className="container mx-auto px-4">
        <div className="mb-12 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <h2 className="mb-4 font-sans text-3xl font-bold tracking-tight text-foreground md:text-4xl lg:text-5xl">
              Tech <span className="text-primary">Perspectives</span>
            </h2>
            <p className="text-lg text-muted-foreground">
              Expert analysis on cloud migration, AI implementation, and the future of digital enterprise in Kenya.
            </p>
          </div>
          <Link to="/InsightsPage">
            <Button variant="outline" className="hidden md:inline-flex">
              View All Insights
            </Button>
          </Link>
        </div>

        <PostsProvider wp_query={wp_query}>
          <TechPerspectivesConsumer />
        </PostsProvider>

        <div className="mt-10 text-center md:hidden">
          <Link to="/InsightsPage">
            <Button variant="outline" className="w-full">
              View All Insights
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}